module.exports = __webpack_public_path__ + "img/gift3-nl.0a889a9d.jpg";